import { defineComponent as _defineComponent } from 'vue'
import { reactive, computed, onMounted, ref } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { numeric, required } from "@vuelidate/validators";
  import store from "@/store";
  import router from "@/router";
  import { StageMapInterface } from "@/types/StageMapInterface";
  import { CreateStageMapInterface } from "@/types/CreateStageMapInterface";
  import { isPngType, isValidFileSize } from "@/helpers/fileUpload";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminStageMapUpdate',
  setup(__props, { expose: __expose }) {
  __expose();

  const userId = router.currentRoute.value.params.userId as string;
  const estateId = router.currentRoute.value.params.estateId as string;
  const stageId = router.currentRoute.value.params.stageId as string;
  const map = ref<StageMapInterface | null>(null);
  const form = reactive({
    width: 0,
    height: 0,
    x: 0,
    y: 0,
    path: "",
    file: null,
  });
  const rules = computed(() => {
    return {
      width: { required, numeric, $autoDirty: true },
      height: { required, numeric, $autoDirty: true },
      x: { required, numeric, $autoDirty: true },
      y: { required, numeric, $autoDirty: true },
      path: { required, $autoDirty: true },
    };
  });
  const v$ = useVuelidate(rules, form);

  onMounted(() => {
    store.dispatch("stage/getStageMap", stageId).then((res) => {
      map.value = res.data;
      form.width = map.value.size.width;
      form.height = map.value.size.height;
      form.x = map.value.binding.x;
      form.y = map.value.binding.y;
      form.path = map.value.path;
    });
  });

  function selectFile(e: any) {
    if (!e.target.files.length) {
      return;
    }

    const selectedFile = e.target.files[0];

    if (!isPngType(selectedFile) || !isValidFileSize(selectedFile)) {
      return;
    }

    form.file = selectedFile;
  }
  function uploadFile() {
    const data = new FormData();

    data.append("file", form.file as File);
    const payload = {
      landownerId: userId,
      estateId,
      stageId,
      data,
    };

    return store.dispatch("stage/uploadStageMapImg", payload);
  }
  async function updateMap() {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    const data: Partial<CreateStageMapInterface> = {
      size: {
        width: form.width,
        height: form.height,
      },
      path: form.path,
      binding: {
        x: form.x,
        y: form.y,
      },
    };

    if (form.file) {
      data.mapImage = (await uploadFile()).data;
    }

    store
      .dispatch("stage/updateStageMap", { id: map.value?._id, data })
      .then(() => {
        router.push({
          name: "AdminStageMap",
          params: { userId, estateId, stageId },
        });
      });
  }

const __returned__ = { userId, estateId, stageId, map, form, rules, v$, selectFile, uploadFile, updateMap, reactive, computed, onMounted, ref, get useVuelidate() { return useVuelidate }, get numeric() { return numeric }, get required() { return required }, get store() { return store }, get router() { return router }, get StageMapInterface() { return StageMapInterface }, get CreateStageMapInterface() { return CreateStageMapInterface }, get isPngType() { return isPngType }, get isValidFileSize() { return isValidFileSize } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})